export default "__VITE_ASSET__3f53b257__"